import React from 'react';
import styled from 'styled-components';

export const PrimaryButton = styled.button`
    background-color: ${props => props.disabled ? '#3f4144' : '#d6001c'};
    padding: ${props => props.padding || '10px 30px'};
    color: ${props => props.disabled ? 'rgba(255, 255, 255, 0.5)' : 'white'};
    cursor: ${props => props.disabled ? 'normal' : 'pointer'};
    margin: ${props => props.margin || 0};
    &:hover {
        ${props => !props.disabled && 'background-color: #ffffff'};
        ${props => !props.disabled && 'color:  #000000'};
    }
    transition: color 0.25s, background-color 0.25s;
`

export const PrimaryButtonWhite = styled.button`
    background-color: ${props => props.disabled ? '#3f4144' : '#FFFFFF'};
    padding: ${props => props.padding || '10px 30px'};
    color: ${props => props.disabled ? 'rgba(255, 255, 255, 0.5)' : '#000000'};
    cursor: ${props => props.disabled ? 'normal' : 'pointer'};
    margin: ${props => props.margin || 0};
    &:hover {
        ${props => !props.disabled && 'background-color: #d6001c'};
        ${props => !props.disabled && 'color:  #FFFFFF'};
    }
    transition: color 0.25s, background-color 0.25s;
`

export const SecondaryButton = styled.button`
    background-color: ${props => props.disabled ? '#3f4144' : '#000000'};
    padding: ${props => props.padding || '10px 30px'};
    color: ${props => props.disabled ? 'rgba(255, 255, 255, 0.5)' : 'white'};
    cursor: ${props => props.disabled ? 'normal' : 'pointer'};
    &:hover {
        ${props => !props.disabled && 'background-color: #ffffff'};
        ${props => !props.disabled && 'color:  #000000'};
    }
    transition: color 0.25s, background-color 0.25s;
    border: 2px solid #fff;
`

export const OutlineButton = styled.button`
    background-color: ${props => props.background || '#000'};
    color: #fff;
    cursor: pointer;
    margin: ${props => props.margin || 0};
    padding: ${props => props.padding || 0};
    font-size: ${props => props.fontSize || '16px'};
    border-bottom: ${props => props.selected ? '3px solid #d6001c' : '3px solid transparent'};
    &:hover {
        color: #D6001C;
    }
    &:focus {
        outline: 0;
    }
    transition: color 0.25s, border-bottom 0.25s;
`

const IconContainer = styled.img.attrs(props => ({
    src: props.src
  }))`
    margin-left: ${props => props.marginLeft || '15px'};
    margin-top: -2px;
`;

export const OutlineButtonIcon = function({ children, onClick, icon, margin, htmlFor, marginLeftIcon, background }) {
    return (
    <div onClick={onClick} style={{display: 'flex', cursor: 'pointer', margin: margin}} htmlFor={htmlFor}>
        <OutlineButton background={background} style={{display: 'flex', alignItems: 'center', borderBottom: 0 }}>
            {children}
            {icon && <IconContainer marginLeft={marginLeftIcon} src={icon} />}
        </OutlineButton>
    </div>);
}